import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { get } from 'lodash';
import { RootState } from 'modules';
import { BiMessageCheck } from 'react-icons/bi';
import { handleFieldError, moveToFirstError } from 'libs/api/errorHandle';
import { cancelMentoringClass } from 'libs/api/mentoring';
import { TMentoringCancel } from 'modules/mentoring';
import { TModalProps } from 'modules/types';
import { EUserType } from 'enums/base.enum';
import { Input, Modal, Button, Row, Typography, Form } from 'antd';
import { FormWrapper } from 'GlobalStyles';

const { Title } = Typography;
const MentoringCancelModal = ({ modalState, setModalState }: TModalProps) => {
  // 멘토링 취소 눌렀을 때 저장 모달의 state를 modalState로 받아줌
  //그 수업의 id값만 거르기
  const mentoringClassId = get(modalState, 'record.id');
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [form] = Form.useForm();
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);

  function handleSubmit() {
    async function handleMentoringCancel(value: TMentoringCancel) {
      try {
        setSubmitButtonDisabled(true);
        await cancelMentoringClass(mentoringClassId, value);
        modalState.onFinish && modalState.onFinish();
        handleCancel();
      } catch (e) {
        handleFieldError(e, form);
        throw e;
      } finally {
        setSubmitButtonDisabled(false);
      }
    }
    form
      .validateFields()
      .then((value) => {
        handleMentoringCancel(value as TMentoringCancel);
      })
      .catch((errorInfo) => {
        moveToFirstError(form, errorInfo.errorFields);
      });
  }

  function handleCancel() {
    setModalState({ visible: false });
    form.resetFields();
  }

  return (
    //모달 antd <Modal> 의 attribute로 title, content, footer
    <Modal
      visible={modalState.visible}
      maskClosable={true}
      closable={true}
      footer={
        <Row justify='end'>
          <Button onClick={handleCancel}>취소</Button>
          <Button danger loading={submitButtonDisabled} onClick={handleSubmit}>
            수업취소하기
          </Button>
        </Row>
      }
      width={680}
      centered={true}
      title={
        <Title level={3} style={{ marginBottom: '0px' }}>
          정말 수업을 취소하시겠어요?
        </Title>
      }
      onCancel={handleCancel}
    >
      <div>
        {/* react-icons/bi 라이브러리에서 import한 아이콘 */}
        <BiMessageCheck style={{ color: '#fbbc05' }} />
        {currentUser?.user_type === EUserType.Mentee ? (
          //멘티가 멘토링 취소 버튼을 눌렀을 경우
          <div style={{ color: '#000', fontSize: '12px' }}>
            <div>• 수업 시작 24시간 이전 : 취소 및 변경 가능 (CREDIT 환급)</div>
            <div>• 수업 시작 24시간 이내 : 취소 및 변경 불가 (CREDIT 차감)</div>
          </div>
        ) : (
          //멘토가 멘토링 취소 버튼을 눌렀을 경우
          <div style={{ color: '#000', fontSize: '12px' }}>
            <div>
              • 수업 시작 8시간 이내 취소 및 변경 시 정규반 기준 12.5만원, 패키지 기준 15만원이 penalty로
              부여되며 이는 불참 멘토링 이후 정산시에 반영됩니다.
            </div>
            <div>
              • 해당 penalty는 멘티 분에게 benefit으로 제공되며, Career Step이 취하는 이익은 없습니다.
            </div>
            <div>
              • 멘토 분들의 경우, 회사 상황들을 고려 8시간 이내 취소 policy를 가져가고 있지만, 한달 내 2회
              이상 반복될 시 2회 발생 후 2달간 멘토링 진행 불가합니다.
            </div>
          </div>
        )}
      </div>
      <FormWrapper style={{ padding: '20px 0px' }}>
        <Form form={form} layout='vertical' className='form-normal'>
          <Form.Item
            name='memo'
            className='form-item no-margin'
            label='취소 사유를 적어주세요'
            rules={[{ required: true }]}
          >
            <Input.TextArea
              className='form_textarea'
              placeholder='취소사유를 자세하게 적어주세요.
예) 이번 시간이 적합하지 않아서 수업이 진행이 다소 어렵습니다. 홍길동님의 양해를 구합니다.'
              autoSize={{ minRows: 5 }}
            />
          </Form.Item>
        </Form>
      </FormWrapper>
    </Modal>
  );
};

export default MentoringCancelModal;
